import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMedicalSquareIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14ZM17 9h-2V7a1.0002 1.0002 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h4a1.0001 1.0001 0 0 0 1-1v-2h2a1.0001 1.0001 0 0 0 1-1v-4a1.0002 1.0002 0 0 0-1-1Zm-1 4h-2a1.0001 1.0001 0 0 0-1 1v2h-2v-2a1.0001 1.0001 0 0 0-1-1H8v-2h2a1.0001 1.0001 0 0 0 1-1V8h2v2a1.0001 1.0001 0 0 0 1 1h2v2Z"/>
  </SvgIcon>
}

export default LineMedicalSquareIcon
